import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 15.75C10.2249 15.75 8.75876 16.5269 7.71094 17.3418C7.18993 17.747 6.7831 18.1529 6.50879 18.4561C6.5038 18.4616 6.49904 18.4672 6.49414 18.4727C7.9776 19.7358 9.89896 20.5 12 20.5C14.1008 20.5 16.0215 19.7355 17.5049 18.4727C17.5001 18.4674 17.4961 18.4614 17.4912 18.4561C17.2169 18.1529 16.8101 17.747 16.2891 17.3418C15.2412 16.5269 13.7751 15.75 12 15.75ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.0528 4.22798 15.9353 5.43945 17.4043C5.75734 17.0571 6.2112 16.6077 6.78906 16.1582C7.99121 15.2232 9.77529 14.25 12 14.25C14.2247 14.25 16.0088 15.2232 17.2109 16.1582C17.7885 16.6075 18.2417 17.0572 18.5596 17.4043C19.7713 15.9353 20.5 14.053 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13C10.067 13 8.5 11.433 8.5 9.5C8.5 7.567 10.067 6 12 6ZM12 7.5C10.8954 7.5 10 8.39543 10 9.5C10 10.6046 10.8954 11.5 12 11.5C13.1046 11.5 14 10.6046 14 9.5C14 8.39543 13.1046 7.5 12 7.5Z"
	})
});
export default SvgMenuUser;
